<script setup lang="ts">
    defineProps({
        minus: String,
        plus: String,
        disabled: { type: Boolean, default: false },
    });

    defineEmits(['minusClicked', 'plusClicked']);
</script>

<template>
    <div class="container">
        <span class="minus-label text-paragraph-sm text-secondary-text">{{ minus }}</span>
        <v-btn
            class="button minus"
            size="40"
            rounded="lg"
            elevation="1.5"
            :disabled="disabled"
            @click="$emit('minusClicked')"
        >
            <v-icon icon="mdi-minus" color="primary" />
        </v-btn>
        <v-btn
            class="button plus"
            size="40"
            rounded="lg"
            elevation="1.5"
            :disabled="disabled"
            @click="$emit('plusClicked')"
        >
            <v-icon icon="mdi-plus" color="primary" />
        </v-btn>
        <span class="plus-label text-paragraph-sm text-secondary-text">{{ plus }}</span>
    </div>
</template>

<style scoped lang="scss">
    .container {
        display: flex;
        margin-bottom: 10px;
        justify-content: center;
    }

    .container span {
        display: flex;
        align-items: center;
        flex-basis: 30%;
    }

    .button {
        margin: 0 6px;
    }

    .button.plus {
        background: var(--bg-mid-grey, #F0F2F5);
    }

    .minus-label {
        margin-right: 20px;
        justify-content: right;
        max-width: 85px;
    }

    .plus-label {
        margin-left: 20px;
        justify-content: left;
        max-width: 85px;
    }
</style>
